import React from 'react';
import InfoTooltip from 'components/shared/InfoTooltip';
import useFetch from 'hooks/useFetch';
import { routes } from 'constants/config';
import Skeleton from 'ui/Skeleton';
import Section, { SectionHeader } from './Section';

const GamificationPoints = () => {
  const { data, loading } = useFetch(routes.GAMIFICATION.POINTING_SYSTEM);

  return (
    <Section>
      <SectionHeader className="d-f jc-sb">
        <span>
          <span className="mr-4">
            {t('paths.path_builder.sidebar.gamification.points')}
          </span>
          <InfoTooltip
            tooltip={t('paths.path_builder.sidebar.gamification.tooltip')}
          />
        </span>
      </SectionHeader>
      {loading ? (
        <div data-testid="pathGamificationLoadingSkeleton">
          <Skeleton count={3} className="mt-12" />
        </div>
      ) : (
        <>
          <div className="d-f jc-sb mb-8">
            <span className="c-brand-gray-darker">
              {t('paths.path_builder.sidebar.gamification.lesson_points')}
            </span>
            <span className="fw-600">{data.lesson}</span>
          </div>
          <div className="d-f jc-sb mb-8">
            <span className="c-brand-gray-darker">
              {t('paths.path_builder.sidebar.gamification.path_points')}
            </span>
            <span className="fw-600">{data.path}</span>
          </div>
          <div className="d-f jc-sb mb-8">
            <span className="c-brand-gray-darker">
              {t(
                'paths.path_builder.sidebar.gamification.certification_points',
              )}
            </span>
            <span className="fw-600">{data.certification}</span>
          </div>
        </>
      )}
    </Section>
  );
};

export default GamificationPoints;
